const apiConfig = {
  // apiBasePath: 'https://testumgebung.dunnet.de/technikkenner_api/',
  apiBasePath: "https://technikkenner.de/technikkenner_api/",
  onePassBasePath: "https://wochenhighlight.de",
  // basePath:'https://testumgebung.dunnet.de/technikkenner'
  basePath: "https://technikkenner.de/",
};

export default apiConfig;

// const apiConfig = {
//   // apiBasePath: 'https://testumgebung.dunnet.de/technikkenner_api/',

//   apiBasePath:
//     process.env.NODE_ENV === "development"
//       ? "/technikkenner_api/"
//       : "https://technikkenner.de/technikkenner_api/",

//   onePassBasePath: "https://wochenhighlight.de",

//   // basePath:'https://testumgebung.dunnet.de/technikkenner'
//   basePath: "https://technikkenner.de/",
// };

// export default apiConfig;
